import { orderSummaryCardStyles } from "@insite/content-library/Components/OrderSummaryCard";
import { billingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { shippingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// OrderDetailsButtonSet
orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        button {
            margin-left: 20px;
        }
    `,
};

billingAddressStyles.wrapper = {
    css: css`
        address {
            width: 95%;
        }
    `,
};

shippingAddressStyles.wrapper = {
    css: css`
        address {
            width: 95%;
        }
    `,
};
